import styles from "@/components/header.module.css";
import * as signals from "@/signals";
import { getPremium } from "@/utils";
import clsx from "clsx";
import { t } from "i18next";
import { JSX } from "react";

function Header(): JSX.Element {
	return (
		<header className={styles["header"]}>
			<div className={clsx("app-icon", styles["app-icon"])}></div>
			<h1>{t("rthWebHosting")}</h1>
			{signals.hasPremium.value === false && (
				<button
					className={styles["badge"]}
					onClick={() => void getPremium()}
					title={t("upgradeToFullVersion")}
					type="button"
				>
					{t("trial")}
				</button>
			)}
		</header>
	);
}

export default Header;
